// components/Layout.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import './Layout.css';

function Layout({ children, onLogout, userRole, username, theme, onToggleTheme }) {
  const capitalizeFirstLetter = (string) => {
    if (!string) return '';
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const navLinkClass = ({ isActive }) => `navLink ${isActive ? 'navLinkActive' : ''}`;

  return (
    <div className="container">
      <header className="header">
        <div className="brand">
          <img src="/logo192.png" alt="HelpPlace" className="brandLogo" />
          <h1 className="appTitle">HelpPlace</h1>
        </div>

        <nav className="nav">
          {userRole !== 'operador' && (
            <NavLink to="/" end className={navLinkClass}>
              Início
            </NavLink>
          )}
          {userRole === 'admin' && (
            <>
              <NavLink to="/users" className={navLinkClass}>
                Usuários
              </NavLink>
              <NavLink to="/servers" className={navLinkClass}>
                Servidores
              </NavLink>
              <NavLink to="/logs" className={navLinkClass}>
                Logs
              </NavLink>
              <NavLink to="/agendamentos" className={navLinkClass}>
                Agendamentos
              </NavLink>
            </>
          )}
          <NavLink to="/monitor-ramais" className={navLinkClass}>
            Ramais
          </NavLink>
          <NavLink to="/monitor-filas" className={navLinkClass}>
            Filas em tempo real
          </NavLink>
          {userRole !== 'operador' && (
            <>
              <NavLink to="/relatorio-filas" className={navLinkClass}>
                Relatório de Filas
              </NavLink>
              <NavLink to="/gravacoes" className={navLinkClass}>
                Gravações
              </NavLink>
            </>
          )}
        </nav>

        <div className="userInfoContainer">
          <button
            className="themeToggle"
            onClick={onToggleTheme}
            title={theme === 'light' ? 'Mudar para tema escuro' : 'Mudar para tema claro'}
            aria-label="Alternar tema"
          >
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
          {username && (
            <span className="usernameText">
              {capitalizeFirstLetter(username)}
            </span>
          )}
          <button onClick={onLogout} className="logoutButton">
            Sair
          </button>
        </div>
      </header>

      <main className="mainContent">{children}</main>

      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} Grupo HelpSistem. Todos os direitos reservados.</p>
      </footer>
    </div>
  );
}

export default Layout;
